import React from 'react'
import axios from 'axios'
import '../css/input.css'
const SendDispatchNotification = (props) => {

    async function handleSubmit(event) {
        const messageEl = document.getElementById('console-message')
        const message = messageEl.value
        const res = await axios({
            method: 'POST',
            url: `/api/dispatch-tablets/notifiy/${props.record.id}`,
            data: {
                message,
                id: props.record.id
            }
        })
        if (res.status === 200) {
            alert('Successfully sent notification')
        } else {
            alert('Error sending notification')
        }
    }
    return (<form class="sos-form" onSubmit={handleSubmit} >
        <div class="field">
            <input
                id="console-message"
                class="sos-input"
                required
            />
            <label class="sos-label" for="console-message">Message</label>
        </div>
        <button class="sos-form-button" type="submit">Send Message</button>
    </form>)
}

export default SendDispatchNotification